import { useState } from "react";
import { createListStore } from "../../common/listStore";
import { renderListStore } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";

interface SystemTaskListItemDto {
    id: number;
    systemTaskTypeId: number;
    attempts: number;
    createdAtUtc: string;
    lastAttemptAtUtc: string | null;
    nextAttemptAtUtc: string | null;
    lastError: string | null;
    data: string | null;
}

const systemTaskTypeName: Record<number, string> = {
    1: "Send order to MailForce",
    2: "Send overweight notification",
    3: "Data cleanup",
    4: "Send SMS to customer",
};

export function SystemTaskListPage() {
    const [useStore] = useState(() => createListStore<SystemTaskListItemDto>({
        path: "systemTasks",
        itemsPerPage: 17,
        getId: p => p.id,
        listProps: [
            { column: "id", label: "Id", width: 80 },
            {
                column: "systemTaskTypeId",
                label: "Type",
                width: 220,
                renderCell: p => systemTaskTypeName[p.row.systemTaskTypeId as number] ?? String(p.value),
            },
            { column: "attempts", label: "Attempts", width: 100, type: "number" },
            { column: "createdAtUtc", label: "Created (UTC)", width: 170, type: "datetime" },
            { column: "lastAttemptAtUtc", label: "Last attempt (UTC)", width: 170, type: "datetime" },
            { column: "nextAttemptAtUtc", label: "Next attempt (UTC)", width: 170, type: "datetime" },
            { column: "lastError", label: "Last error", width: 420 },
            { column: "data", label: "Data", width: 280 },
        ],
    }));

    return <>
        <PageTitle title="System tasks" />
        {renderListStore(useStore, { readOnly: true })}
    </>;
}
